import { connect } from 'react-redux';
import { IReduxState, TThunkDispatch } from '../../types/redux';
import { setMortgageDownPayment } from '../../actions/mortgage';
import { FilterAmountInput, IFilterAmountInputProps } from '../../components/FilterAmountInput';

type TFilterMortgageDownPaymentStateProps = Pick<
  IFilterAmountInputProps,
  'integerLimit' | 'placeholder' | 'suffix' | 'value'
>;
type TFilterMortgageDownPaymentDispatchProps = Pick<IFilterAmountInputProps, 'onValueChange'>;

export function mapStateToProps(state: IReduxState): TFilterMortgageDownPaymentStateProps {
  return {
    integerLimit: 12,
    placeholder: 'Первоначальный взнос',
    suffix: `\u20BD`,
    value: state.mortgage.filterDownPayment,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterMortgageDownPaymentDispatchProps {
  return {
    onValueChange: (value: number) => {
      dispatch(setMortgageDownPayment(value));
    },
  };
}

export const FilterMortgageDownPaymentContainer = connect(mapStateToProps, mapDispatchToProps)(FilterAmountInput);
